// extracted by mini-css-extract-plugin
export default {"container":"Conversation_container__he-Ny","space_blank":"Conversation_space_blank__+o7mD"};